import { useMemo } from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';

import type { PortalUser } from './types';

export function usePortalUser(): PortalUser {
  const userId = useAppSelector((state) => state.account?.AccountId);
  const role = useAppSelector((state) => state.currentApp?.AppAccessLevel);
  const permissions = useAppSelector((state) => state.permissions ?? []);

  return useMemo(
    () => ({
      userId,
      role,
      permissions,
    }),
    [userId, role, permissions]
  );
}
